import { combineReducers } from "redux";

import locale from "./Locale/reducer";
import auth from "./Auth/reducer";
import cart from "./Cart/reducer";
import terms from "./Terms/reducer";
import filters from "./Filters/reducer";

const rootReducer = combineReducers({
  locale,
  auth,
  cart,
  terms,
  filters,
});

export default rootReducer;
